import { createApp } from 'vue'
import App from './AppShell.vue' // 我们稍后创建一个壳组件
import router from './router'

const app = createApp(App)
app.use(router)
app.mount('#app')